import { MoveRight, PhoneCall } from 'lucide-react'
import { AnimatedStatusButton } from '#app/components/ui/animated-status-button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '#app/components/ui/dialog'

interface IncomeReassuranceModalProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	/** Guarantors see a slightly different reassurance line. */
	isGuarantor?: boolean
}

export function IncomeReassuranceModal({
	open,
	onOpenChange,
	isGuarantor = false,
}: IncomeReassuranceModalProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				className="rounded-[20px] border border-[#E5E5E5] bg-[#fbfdfd] p-0 shadow-xl sm:max-w-xl"
				showCloseButton={true}
			>
				<div className="p-8">
					<div className="mb-6 flex justify-center">
						<div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#16A34A0D]">
							<img src="/img/Call.svg" alt="Call" className="h-9 w-9" />
						</div>
					</div>

					<DialogHeader className="mb-4 items-center text-center">
						<DialogTitle className="font-calgary text-center text-[28px] text-[#32302F] md:text-[24px]">
							Have Questions About Income Verification?
						</DialogTitle>
					</DialogHeader>

					<DialogDescription className="mx-auto mb-6 text-center text-[16px] leading-relaxed text-[#32302F]">
						{isGuarantor
							? 'Our AI agent is calling you to answer any questions before you proceed'
							: 'Our AI agent is calling you to answer any questions'}
					</DialogDescription>

					<div className="flex justify-center">
						<AnimatedStatusButton
							type="button"
							onClick={() => onOpenChange(false)}
							status="idle"
							className="rounded-[30px] border-0 bg-[#32302F] px-6 py-[12px] text-[16px] font-medium text-white transition-colors duration-200 hover:bg-[#1a1918] active:bg-[#0f0f0e] sm:px-8 sm:py-[16px]"
						>
							I’m ready
							<MoveRight />
						</AnimatedStatusButton>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
